import DictionaryEntriesWidget from './DictionaryEntriesWidget.vue';

export { default as iconMap } from './icons';

export default DictionaryEntriesWidget;
